import { render, staticRenderFns } from "./slaCategoryPeriod.vue?vue&type=template&id=d8e1eed8&"
import script from "./slaCategoryPeriod.vue?vue&type=script&lang=js&"
export * from "./slaCategoryPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports